import {
	AcceptanceStatus,
	GetKYCInvestorInstanceRes,
	KYCFileType,
	KYCWorkflowFileItemRes,
	SubjectAction,
} from '@dealstack/shared/lib/generated';
import { DocumentStatusCell } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/components/DocumentStatusCell';
import { DocumentStatusDot } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/components/DocumentStatusDot';
import { REQUESTED_STATUS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/components/utils';
import {
	Step,
	StepType,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { toDocumentStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepTabs/utils/toDocumentStatus';
import { isStepInherited } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepTabs/utils/isStepInherited';
import { overallFormStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepTabs/utils/overallFormStatus';
import { isAwaitingCertifier } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/utils/certificationReview.utils';
import { useFormStepPillFiles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepTabs/useFormStepPillFiles';

interface Props {
	step: Step;
	currentInvestor?: GetKYCInvestorInstanceRes;
	mipId?: string;
}

export const StepStatusIndicator = ({ step, currentInvestor, mipId }: Props) => {
	const formStepPillFiles = useFormStepPillFiles({ mipId, currentInvestor });

	if (step.type === StepType.FORM) {
		return (
			<DocumentStatusCell
				files={formStepPillFiles}
				overallStatus={toDocumentStatus(overallFormStatus(formStepPillFiles))}
				isExpanded={false}
				fallbackName={step.title}
			/>
		);
	}

	if (step.type === StepType.INVESTMENT_VEHICLE) {
		const files: KYCWorkflowFileItemRes[] =
			currentInvestor?.kycFiles
				?.filter(
					(kycFile) => kycFile.type === KYCFileType.INVESTMENT_VEHICLE && !kycFile.deleted
				)
				.map((kycFile) => ({
					id: kycFile.id,
					fileName: kycFile.file?.name ?? '',
					status: kycFile.status as AcceptanceStatus | null,
					isInherited: kycFile.subjectAction === SubjectAction.NOT_YET_ACTED,
					isAwaitingCertifier: isAwaitingCertifier(kycFile),
				})) ?? [];

		return (
			<DocumentStatusCell
				files={files}
				overallStatus={toDocumentStatus(step.approvalStatus)}
				isExpanded={false}
				fallbackName={step.title}
			/>
		);
	}

	const inherited = isStepInherited(step, currentInvestor);
	const status = inherited ? REQUESTED_STATUS : toDocumentStatus(step.approvalStatus);
	return <DocumentStatusDot status={status} isInherited={inherited} />;
};
